import { render, staticRenderFns } from "./configurati.vue?vue&type=template&id=0b6cd27e&scoped=true"
import script from "./configurati.vue?vue&type=script&lang=js"
export * from "./configurati.vue?vue&type=script&lang=js"
import style0 from "./configurati.vue?vue&type=style&index=0&id=0b6cd27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cd27e",
  null
  
)

export default component.exports